<template>
  <section>
    <!--工具条-->
    <siteToolbar :buttonList="buttonList" @callFunction="callFunction"></siteToolbar>

    <!--列表-->
    <el-table :data="sites" highlight-current-row v-loading="listLoading" @current-change="selectCurrentRow"
      style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="80"></el-table-column>
      <el-table-column fixed="left" label="操作" width="80">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide"
              @click="operationButtonFunction(item, scope.row)">{{ item.name }}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="LineChineseName" label="公交线路中文名称" width="200" sortable></el-table-column>
      <el-table-column prop="LineEnglishName" label="公交线路英文名称" width="200" sortable></el-table-column>
      <el-table-column prop="RunningDirection" label="线路方向" width="200" sortable></el-table-column>
      <el-table-column prop="BusLineDirectionChineseName" label="公交线路方向中文名称" width="200" sortable></el-table-column>
      <el-table-column prop="BusLineDirectionEnglishName" label="公交线路方向英文名称" width="500" sortable></el-table-column>
      <el-table-column prop="SiteNumber" label="站点编号" width="100" sortable></el-table-column>
      <el-table-column prop="SiteChineseName" label="站点中文名称" width="150" sortable></el-table-column>
      <el-table-column prop="SiteEnglishName" label="站点英文名称" width="320" sortable></el-table-column>
      <el-table-column prop="ApprovedDistance" label="到站核定距离" width="220" :formatter="ApprovedDistanceFormat"
        sortable></el-table-column>
      <el-table-column prop="ViaBusLine" label="途径公交线路" width="150" sortable></el-table-column>
      <el-table-column prop="Longitude" label="经度" width="150" sortable></el-table-column>
      <el-table-column prop="Latitude" label="纬度" width="150" sortable></el-table-column>
      <el-table-column prop="MapIsDisplay" label="地图是否显示" width="200" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.MapIsDisplay ? 'success' : 'danger'" disable-transitions>{{ scope.row.MapIsDisplay ?
            "是" : "否" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="100" sortable>
      </el-table-column>
      <el-table-column prop="Enabled" label="状态" width="200" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.Enabled ? 'success' : 'danger'" disable-transitions>{{ scope.row.Enabled ?
            "正常" : "禁用" }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" width="65%"
      :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="公交线路" prop="BusLinesId" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.BusLinesId" placeholder="请选择公交线路">
                <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
                  <span style="float: left">{{ item.LineChineseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="editForm.Enabled" placeholder="请选择站点状态">
                <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="线路方向" prop="RunningDirection" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.RunningDirection" placeholder="请选择线路方向">
                <el-option v-for="item in lineModeList" :key="item.Id" :value="item.DictName" :label="item.DictName">
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="地图是否显示" prop="MapIsDisplay" label-width="110px">
              <el-select v-model="editForm.MapIsDisplay" placeholder="请选择站点状态">
                <el-option v-for="item in mapIsDisplayList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="线路方向中文" prop="BusLineDirectionChineseName" label-width="110px">
              <el-input style="width:210px;" v-model="editForm.BusLineDirectionChineseName" />
              <el-button type="primary" @click.native="editFormBusLineDirectionTranslation">翻译</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路方向英文" prop="BusLineDirectionEnglishName" label-width="110px">
              <el-input v-model="editForm.BusLineDirectionEnglishName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="站点编号" prop="SiteNumber" label-width="110px">
              <el-input v-number-only v-model="editForm.SiteNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="途径公交线路" prop="ViaBusLine" label-width="110px">
              <el-input v-model="editForm.ViaBusLine" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="站点中文名称" prop="SiteChineseName" label-width="110px">
              <el-input style="width:210px;" v-model="editForm.SiteChineseName" />
              <el-button type="primary" @click.native="editFormSiteTranslation">翻译</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="站点英文名称" prop="SiteEnglishName" label-width="110px">
              <el-input v-model="editForm.SiteEnglishName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="经度" prop="Longitude" label-width="110px">
              <el-input v-model="editForm.Longitude" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="纬度" prop="Latitude" label-width="110px">
              <el-input v-model="editForm.Latitude" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="站点方位" prop="Direction" label-width="110px">
              <el-input v-model="editForm.Direction" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="到站核定距离" prop="ApprovedDistance" label-width="110px">
              <el-input v-number-only style="width:210px;" v-model="editForm.ApprovedDistance" /> 米
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" width="65%"
      :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="公交线路" prop="BusLinesId" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.BusLinesId" placeholder="请选择公交线路">
                <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
                  <span style="float: left">{{ item.LineChineseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="addForm.Enabled" placeholder="请选择站点状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="线路方向" prop="RunningDirection" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.RunningDirection" placeholder="请选择线路方向">
                <el-option v-for="item in lineModeList" :key="item.Id" :value="item.DictName" :label="item.DictName">
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="地图是否显示" prop="Enabled" label-width="110px">
              <el-select v-model="addForm.MapIsDisplay" placeholder="请选择地图是否显示">
                <el-option label="是" value="true"></el-option>
                <el-option label="否" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="线路方向中文" prop="BusLineDirectionChineseName" label-width="110px">
              <el-input style="width:210px;" v-model="addForm.BusLineDirectionChineseName" />
              <el-button type="primary" @click.native="addFormBusLineDirectionTranslation">翻译</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路方向英文" prop="BusLineDirectionEnglishName" label-width="110px">
              <el-input v-model="addForm.BusLineDirectionEnglishName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="站点编号" prop="SiteNumber" label-width="110px">
              <el-input v-number-only v-model="addForm.SiteNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="途径公交线路" prop="ViaBusLine" label-width="110px">
              <el-input v-model="addForm.ViaBusLine" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="站点中文名称" prop="SiteChineseName" label-width="110px">
              <el-input style="width:210px;" v-model="addForm.SiteChineseName" />
              <el-button type="primary" @click.native="addFormSiteTranslation">翻译</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="站点英文名称" prop="SiteEnglishName" label-width="110px">
              <el-input v-model="addForm.SiteEnglishName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="经度" prop="Longitude" label-width="110px">
              <el-input v-model="addForm.Longitude" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="纬度" prop="Latitude" label-width="110px">
              <el-input v-model="addForm.Latitude" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="站点方位" prop="Direction" label-width="110px">
              <el-input v-model="addForm.Direction" />
            </el-form-item>
          </el-col>

          <el-col :span="10" style="float:right;">
            <el-form-item label="到站核定距离" prop="ApprovedDistance" label-width="110px">
              <el-input v-number-only style="width:210px;" v-model="addForm.ApprovedDistance" /> 米
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog title="操作日记" :visible.sync="operateDataLogFormVisible" v-model="operateDataLogFormVisible"
      :close-on-click-modal="false" :destroy-on-close="true" width="60%">
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入 Excel 文件" :visible.sync="importExcelFormVisible" v-model="importExcelFormVisible" width="35%"
      :close-on-click-modal="false">
      <ImportExcel :action="action">

      </ImportExcel>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getBusLinesListPage, getSiteListPage, getDictionaryListPageByDictNameAndDictCode, removeSite, editSite, addSite, baiduTrans, importSiteDataUrl, SaveExcel } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import SiteToolbar from "../../components/QueryToolbar/SiteToolbar";
import OperateDataLog from "../../components/OperateDataLog";
import ImportExcel from "../Upload/ImportExcel";

export default {
  components: {
    SiteToolbar,
    OperateDataLog,
    ImportExcel
  },
  data() {
    return {
      filters: {
        siteName: "",
        busLinesId: "",
        busLineDirectionName: ""
      },
      entityName: 'Site', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      action: '',
      operationButtonList: [],
      lineModeList: [],
      sites: [], //站点列表
      busLiness: [], //线路列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      mapIsDisplayList: [
        { name: "是", value: true },
        { name: "否", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      importExcelFormVisible: false, //导入页面是否显示
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        BusLinesId: [{ required: true, message: "请输入公交线路", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        MapIsDisplay: [{ required: true, message: "请选择地图上是否显示", trigger: "blur" }],
        BusLineDirectionChineseName: [{ required: true, message: "请输入公交线路方向中文名称", trigger: "blur" }],
        SiteNumber: [{ required: true, message: "请输入站点编号", trigger: "blur" }],
        SiteChineseName: [{ required: true, message: "请输入站点中文名称", trigger: "blur" }],
        Longitude: [{ required: true, message: "请输入经度", trigger: "blur" }],
        Latitude: [{ required: true, message: "请输入纬度", trigger: "blur" }],
        RunningDirection: [{ required: true, message: "请输入线路方向", trigger: "blur" }],
        ApprovedDistance: [{ required: true, message: "请输入到站核定距离", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        Enabled: false,
        MapIsDisplay: true,
        BusLinesId: 0,
        SiteNumber: "",
        BusLineDirectionChineseName: "",
        BusLineDirectionEnglishName: "",
        SiteChineseName: "",
        SiteEnglishName: "",
        Longitude: "",
        Latitude: "",
        RunningDirection: "",
        ApprovedDistance: "",
        ViaBusLine: "",
        Direction: ""
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        BusLinesId: [{ required: true, message: "请输入公交线路", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        MapIsDisplay: [{ required: true, message: "请选择地图上是否显示", trigger: "blur" }],
        BusLineDirectionChineseName: [{ required: true, message: "请输入公交线路方向中文名称", trigger: "blur" }],
        SiteNumber: [{ required: true, message: "请输入站点编号", trigger: "blur" }],
        SiteChineseName: [{ required: true, message: "请输入站点中文名称", trigger: "blur" }],
        Longitude: [{ required: true, message: "请输入经度", trigger: "blur" }],
        Latitude: [{ required: true, message: "请输入纬度", trigger: "blur" }],
        RunningDirection: [{ required: true, message: "请输入线路方向", trigger: "blur" }],
        ApprovedDistance: [{ required: true, message: "请输入到站核定距离", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        Enabled: "true",
        MapIsDisplay: "true",
        BusLinesId: 0,
        SiteNumber: "",
        BusLineDirectionChineseName: "",
        BusLineDirectionEnglishName: "",
        SiteChineseName: "",
        SiteEnglishName: "",
        Longitude: "",
        Latitude: "",
        RunningDirection: "",
        ApprovedDistance: 0,
        ViaBusLine: "",
        Direction: ""
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    addFormBusLineDirectionTranslation: function () {
      let para = { q: this.addForm.BusLineDirectionChineseName };
      baiduTrans(para).then(res => {
        this.addForm.BusLineDirectionEnglishName = res.data.response;
      });
    },
    editFormBusLineDirectionTranslation: function () {
      let para = { q: this.editForm.BusLineDirectionChineseName };
      baiduTrans(para).then(res => {
        this.editForm.BusLineDirectionEnglishName = res.data.response;
      });
    },
    addFormSiteTranslation: function () {
      let para = { q: this.addForm.SiteChineseName };
      baiduTrans(para).then(res => {
        this.addForm.SiteEnglishName = res.data.response;
      });
    },
    editFormSiteTranslation: function () {
      let para = { q: this.editForm.SiteChineseName };
      baiduTrans(para).then(res => {
        this.editForm.SiteEnglishName = res.data.response;
      });
    },
    callFunction(item) {
      this.filters = {
        siteName: item.siteName,
        busLinesId: item.busLinesId,
        busLineDirectionName: item.busLineDirectionName
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item, row) {
      this.currentRow = row;
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    approvedDistanceFormat(row, column) {
      return row.ApprovedDistance + ' 米';
    },
    onlyNumber(type) {
      if (type === "Add")
        this.addForm["ApprovedDistance"] = this.addForm["ApprovedDistance"].replace(/[^\d.]/g, "").replace(/\.{2,}/g, ".").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      else if (type === "Edit")
        this.editForm["ApprovedDistance"] = this.editForm["ApprovedDistance"].replace(/[^\d.]/g, "").replace(/\.{2,}/g, ".").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getSite();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getSite();
    },
    querySite() {
      this.page = 1;
      this.getSite();
    },
    //获取线路列表
    getSite() {
      let _this = this;
      let para = {
        page: _this.page,
        pageSize: _this.pageSize,
        siteName: _this.filters.siteName,
        busLinesId: _this.filters.busLinesId,
        busLineDirectionName: _this.filters.busLineDirectionName
      };
      _this.listLoading = true;
      getSiteListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.sites = res.data.response.data;
        _this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeSite(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getSite();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        Enabled: "true"
      };
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    // 导入站点数据 Excel 文件
    handleImport() {
      this.importExcelFormVisible = true;
      this.action = importSiteDataUrl;
    },
    handleSaveExcel() {
      let para = {
      };
      SaveExcel(para).then(res => {
        
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            editSite(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getSite();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addSite(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getSite();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getSite();

    let pageSizePara = {
      pageSize: 100
    };
    getBusLinesListPage(pageSizePara).then(res => {
      this.busLiness = res.data.response.data;
    });

    let para = {
      dictName: '线路模式',
      dictCode: 'LineMode',
      pageSize: 100
    };
    getDictionaryListPageByDictNameAndDictCode(para).then(res => {
      this.lineModeList = res.data.data;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped></style>
